import {FrequencyUnit} from 'src/openapi/admin/models/FrequencyUnit';

import type {DictionaryItem} from 'src/openapi/admin/models/DictionaryItem';

export const SECTION_NAME = 'FullStory Configurator';

export const MAX_FREQUENCY_MAP = {
    [FrequencyUnit.DAYS]: 365,
    [FrequencyUnit.HOURS]: 23,
    [FrequencyUnit.MINUTES]: 59,
};

export const FREQUENCY_UNIT_OPTIONS: DictionaryItem[] = [
    {code: FrequencyUnit.MINUTES, description: 'minutes'},
    {code: FrequencyUnit.HOURS, description: 'hours'},
    {code: FrequencyUnit.DAYS, description: 'days'},
];
